import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import PropTypes from "prop-types";

export function OrganizationMemberSelectBox({
  orgUsers,
  setOrgUser,
  setShowAddBtn = null,
}) {
  const handleChange = (event) => {
    let orgUserId = event.target.value;
    orgUsers.forEach((user) => {
      if (user.id == orgUserId) {
        setOrgUser(user);
        if (setShowAddBtn) {
          setOrgUser(user);
          setShowAddBtn(true);
        }
      }
    });
  };

  let orgUserList = null;
  if (orgUsers != null) {
    orgUserList = orgUsers.map((user, i) => {
      return (
        <MenuItem value={user.id} key={i}>
          {user.UserName}
        </MenuItem>
      );
    });
  }

  const isLoading = orgUsers == null;

  return (
    <FormControl sx={{ m: 1, minWidth: 120 }}>
      <InputLabel id="demo-simple-select-helper-label">
        {isLoading ? "読み込み中..." : "組織"}
      </InputLabel>
      <Select
        labelId="demo-simple-select-helper-label"
        id="demo-simple-select-helper"
        label="OrganizationMember"
        onChange={handleChange}
        defaultOpen
        size="small"
        disabled={isLoading}
      >
        {orgUserList}
      </Select>
    </FormControl>
  );
}

OrganizationMemberSelectBox.propTypes = {
  orgUsers: PropTypes.object,
  setOrgUser: PropTypes.object,
  setShowAddBtn: PropTypes.bool,
};
